// DATA
export const FETCH_DATA = 'PAYMENTS/FETCH_DATA'

// ACCOUNTS
export const FETCH_ACCOUNT = 'PAYMENTS/FETCH_ACCOUNT'
export const FETCH_ACCOUNTS = 'PAYMENTS/FETCH_ACCOUNTS'
export const ACCOUNT_SUCCESS = 'PAYMENTS/ACCOUNT_SUCCESS'
export const ACCOUNT_LOADING = 'PAYMENTS/ACCOUNT_LOADING'
export const ACCOUNT_ERROR = 'PAYMENTS/ACCOUNT_ERROR'

// ADDRESS WHITELISTING
export const FETCH_WHITELIST_ADDRESSES = 'PAYMENTS/FETCH_WHITELIST_ADDRESSES'
export const SET_WITHDRAWALS_NEXT_URL = 'PAYMENTS/SET_WITHDRAWALS_NEXT_URL'
export const SET_WHITELIST_ADDRESSES = 'PAYMENTS/SET_WHITELIST_ADDRESSES'
export const SET_WHITELIST_CAPABILITIES = 'PAYMENTS/SET_WHITELIST_CAPABILITIES'
export const REMOVE_WHITELIST_ADDRESS = 'PAYMENTS/REMOVE_WHITELIST_ADDRESS'
export const SET_WHITELIST_ADDRESSES_ENABLED = 'PAYMENTS/SET_WHITELIST_ADDRESSES_ENABLED'

// BENEFICIARIES
export const FETCH_BENEFICIARIES = 'PAYMENTS/FETCH_BENEFICIARIES'
export const BENEFICIARIES_SUCCESS = 'PAYMENTS/BENEFICIARIES_SUCCESS'
export const BENEFICIARIES_LOADING = 'PAYMENTS/BENEFICIARIES_LOADING'
export const BENEFICIARIES_ERROR = 'PAYMENTS/BENEFICIARIES_ERROR'
export const REMOVE_BENEFICIARY = 'PAYMENTS/REMOVE_BENEFICIARY'

// CURRENCIES
export const SET_CURRENCIES = 'PAYMENTS/SET_CURRENCIES'

// WITHDRAWAL MINS/FEES
export const FETCH_WITHDRAWAL_MINS_AND_FEES = 'PAYMENTS/FETCH_WITHDRAWAL_MINS_AND_FEES'
export const SET_WITHDRAWAL_FEES = 'PAYMENTS/SET_WITHDRAWAL_FEES'
export const SET_WITHDRAWAL_MINIMUMS = 'PAYMENTS/SET_WITHDRAWAL_MINIMUMS'

export * from './BankTransfer/actionTypes'
export * from './Elegible/actionTypes'
export * from './Methods/actionTypes'
export * from './Payment/actionTypes'
export * from './SubmitDeposit/actionTypes'
export * from './Transactions/actionTypes'
export * from './WithdrawFeesAndMin/actionTypes'
